import { useRoutes } from "react-router-dom"
import useSetCurrentPermission from "../hook/routes/useSetCurrentPermission";
import useGetFilterRoutes from "../hook/routes/useGetFilterRoutes";

export default function RenderRoute() {
    useSetCurrentPermission()
    const filteredRoute = useGetFilterRoutes()

    const render = useRoutes(filteredRoute)
    return render;
}


